<ng-container [formGroup]="formGroup">
  <fieldset>
    <legend>{{ 'Default Value' | translate | locale }}</legend>
    <app-product-field
      controlName="DefaultValue"
      [enableCreateOption]="false"
      [formGroup]="formGroup"
      [field]="field"
      [dropDownsMetaData]="dropDownMeta"
    ></app-product-field>
  </fieldset>
</ng-container>
